/* eslint-disable react/no-array-index-key */
import React from 'react';
import styled from 'styled-components';
import { errorColor } from '~theme';

import addSVG from '~images/pake_plus_lightblue.svg';
import removeSVG from '~images/trashbin_blue.svg';

const MultiTextInput = ({ value, onChange, addLabel, removeLabel }) => {
  const handleChange = index => event => {
    const { value: newItem } = event.target;
    const newValue = [...value];
    newValue[index] = newItem;
    onChange(newValue);
  };

  const handleAdd = () => onChange([...value, '']);
  const handleRemove = index => () => {
    onChange(value.filter((_, i) => i !== index));
  };

  return (
    <Container>
      {value?.map((item, index) => (
        <Value key={index}>
          <Component
            value={item}
            onChange={handleChange(index)}
            type="text"
            className="form-control"
          />
          {value.length > 1 && (
            <Remove type="button" onClick={handleRemove(index)}>
              <RemoveIcon src={removeSVG} />
            </Remove>
          )}
        </Value>
      ))}
      <Add type="button" onClick={handleAdd}>
        <AddIcon src={addSVG} /> {addLabel}
      </Add>
    </Container>
  );
};

const Container = styled.div`
  max-width: var(--field-width);
`;

const Value = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
`;

const Component = styled.input`
  ${props => (props.error ? `border-color: ${errorColor};` : '')}
  font-size: 16px;
`;

const Add = styled.button`
  display: flex;
  align-items: center;
  color: var(--lightBlue);
  // margin-top: 16px;
`;

const Remove = styled.button`
  display: flex;
  align-items: center;
`;

const AddIcon = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 8px;
`;

const RemoveIcon = styled.img`
  width: 16px;
  height: 16px;
`;

export default MultiTextInput;
